"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _common = require("./common.js");

var _constants = require("./constants.js");

var _strings = _interopRequireDefault(require("./strings.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable react/prop-types*/
var FrameComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FrameComponent, _React$Component);

  function FrameComponent() {
    _classCallCheck(this, FrameComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(FrameComponent).apply(this, arguments));
  }

  _createClass(FrameComponent, [{
    key: "getLocale",
    value: function getLocale() {
      if (this.props.locale) {
        return this.props.locale;
      }

      var currentLocale = (0, _common.getCurrentLocale)();

      if (this.props.availableLocales && this.props.availableLocales.indexOf(currentLocale) === -1) {
        return _constants.DEFAULT_LOCALE;
      }

      return currentLocale;
    }
  }, {
    key: "getLocaleUrlSuffixForWWW",
    value: function getLocaleUrlSuffixForWWW() {
      var locale = this.getLocale();

      if (locale === _constants.DEFAULT_LOCALE || _constants.DEFAULT_AVAILABLE_LOCALES.indexOf(locale) === -1) {
        return '';
      }

      return "l/".concat(locale.toLowerCase(), "/");
    }
  }, {
    key: "createStringSelector",
    value: function createStringSelector() {
      var localeLower = this.getLocale().toLowerCase();

      var defaultLocaleLower = _constants.DEFAULT_LOCALE.toLowerCase();

      return function (string) {
        if (_strings["default"][localeLower] && _strings["default"][localeLower][string]) {
          return _strings["default"][localeLower][string];
        }

        if (_strings["default"][defaultLocaleLower] && _strings["default"][defaultLocaleLower][string]) {
          return _strings["default"][defaultLocaleLower][string];
        }

        return _constants.UNRESOLVED_STRING;
      };
    }
  }]);

  return FrameComponent;
}(_react["default"].Component);

exports["default"] = FrameComponent;